module.exports = __webpack_public_path__ + "img/5e4316b7b1efab84cc51039ec448fdf2.svg";